import { Theme } from "@mui/material"

export default (theme: Theme) => ({
  alignItems: 'stretch',
  display: 'flex',
  flexDirection: 'column'
} as const);
